/**
 * @owner @Appboy/intelligence
 */

import { z } from "zod";

export const contentOptimizationPhases = ["learning", "action_recommended", "optimizing"] as const;

export const contentOptimizationPhaseSchema = z.enum(contentOptimizationPhases);

export type ContentOptimizationPhase = z.infer<typeof contentOptimizationPhaseSchema>;
